import axios from "axios";
export default {
    state:{
        allitems:[],
    },
    mutations:{
        setProductos(state,items){
            state.allitems=items
        }
    },
    actions:{
        async setProductos({commit,rootState,getters}){           
           await axios.get(`${rootState.urlapi}/inmuebles`,getters.getTokenUser).then(response=>{
                    commit('setProductos',response.data)  
              }).catch(err=>{console.error(err)});
        },
        async decrementStock({rootState,getters},idventa){
           return  await axios.put(`${rootState.urlapi}/inmuebles/decrementstock/${idventa}`,{},getters.getTokenUser)
        },
        async updateProducto({rootState,getters},item){
          return   await axios.put(`${rootState.urlapi}/inmuebles/${item.idarticulo}`,item,getters.getTokenUser)
        }
    },
    getters:{
        getAllProductos(state){
            //Si existe un registro retornamos el arreglo
            if(state.allitems[0])return state.allitems
            //Sino existen registros retornamos un array vacio
            return []
        },
        getProductosActivos(state){
            if(state.allitems[0])return state.allitems
            //Sino existen registros retornamos un array vacio
            return []
        }
        
    }
}